import React, { Component } from "react";
import Axios from "axios";
import FoldersTable from "./FoldersTable";
import CampaignsTable from "./CampaignsTable";
import CreateFolderForm from "./CreateFolderForm";
import loadingSvg from "../../images/loading.svg";
import { Alert } from "react-bootstrap";
import CreateCampaignButton from "./CreateCampaignButton";
import {withRouter} from "../../helpers/withRouter";

class FolderView extends Component {
    state = {
        folder: null,
        parentFolder: null,
    };

    componentDidMount() {
        this.getFolderAPI();
    }

    componentDidUpdate(prevProps) {
        const newId = this.props.match.params.folderId;
        const oldId = prevProps.match.params.folderId;
        if (newId !== oldId) {
            this.setState({
                folder: null,
                parentFolder: null,
            });
            this.getFolderAPI();
        }
    }

    getFolderAPI() {
        let folderId = this.props.match.params.folderId;
        Axios.get(process.env.REACT_APP_BACKEND_URL + "/folder/" + folderId).then(response => {
            this.setState({ folder: response.data });
            if (response.data?.parent) {
                Axios.get(process.env.REACT_APP_BACKEND_URL + "/folder/" + response.data?.parent).then(response => {
                    this.setState({ parentFolder: response.data });
                });
            }
        }).catch(error => {
            if (error?.response) {
                this.setState({
                    error: {
                        title: "Unable to Fetch Folder!",
                        body: error?.response?.data?.message,
                    }
                });
            }
        });
    }

    render() {
        const { folder, parentFolder, error } = this.state;
        const { history } = this.props;
        return (
            <>
                {folder ?
                    <div className="container-md pt-5">
                        <div className="d-flex justify-content-between flex-wrap">
                            <div className="d-flex">
                                <h1
                                    onClick={() => history.go(-1)}
                                    style={{ cursor: 'pointer' }}
                                >
                                    {"<"}
                                </h1>
                                <h1 className="ms-5">{folder?.name}</h1>
                            </div>
                            <div>
                                <CreateCampaignButton createParams={{ folderId: folder?.id}} />
                            </div>
                        </div>
                        <FoldersTable 
                            folders={folder?.subfolders || []} 
                            parentFolder={parentFolder} 
                            refetchData={this.getFolderAPI.bind(this)}
                        />
                        <CreateFolderForm
                            folderId={folder?.id}
                            refetchData={this.getFolderAPI.bind(this)}
                        />
                        <CampaignsTable 
                            campaigns={folder?.campaigns || []} 
                            subfolders={folder?.subfolders}
                            parentFolder={parentFolder} 
                            refetchData={this.getFolderAPI.bind(this)}
                        />
                        {!folder?.campaigns?.length ?
                            <h4 className="mt-5 pt-5 pb-5 text-center w-100 ft-lg">No Campaigns Have Been Created</h4>
                            : <></>
                        }
                        <div className="mt-5 text-center">
                            <CreateCampaignButton createParams={{ folderId: folder?.id}} />
                        </div>

                    </div>
                    : (
                        <div className="full-loading-screen">
                            <div>
                                <img src={loadingSvg} alt="loading icon" />
                                <h4>Loading Folder...</h4>
                            </div>
                        </div>
                    )}
                {error?.title && (
                    <Alert style={{ maxWidth: 500, position: "fixed", right: 10, top: 10 }} variant="danger"
                        onClose={() => this.setState({ error: null })} dismissible>
                        <Alert.Heading>{error?.title}</Alert.Heading>
                        <p>{error?.body}</p>
                    </Alert>
                )}
            </>
        )
    }
}

export default withRouter(FolderView);